// Imports
	// React
	import { Link, NavLink } from 'react-router-dom';
	// Components
	import CartWidget from '../components/CartWidget';
	// Icons
	import { FaBars } from "react-icons/fa";
	// Media
	import Logo from '../media/logo.png';





// rafce

const NavBar = () => {


	// Mobile menu
	let navBarClosed = true;
	// Click en button
	const buttonHandler = () => {
		const navBarElements = document.getElementsByClassName('nav-bar-menu')[0];
		if(navBarClosed){
			navBarElements.classList.add('display-flex-from-upper-left');
			navBarClosed = false;
		}
		else{
			navBarElements.classList.remove('display-flex-from-upper-left');
			navBarClosed = true;
		}
	}
	// Click afuera
	window.addEventListener('click', function(e){
		const navBarElements = document.getElementsByClassName('nav-bar-menu')[0];
		const navBarButton = document.getElementsByClassName('nav-bar-button')[0];
		if(!navBarElements.contains(e.target) && !navBarButton.contains(e.target)){
			navBarElements.classList.remove('display-flex-from-upper-left');
			navBarClosed = true;
		}
	})
	// Click en una opción
	const linkHandler = () => {
		const navBarElements = document.getElementsByClassName('nav-bar-menu')[0];
		navBarElements.classList.remove('display-flex-from-upper-left');
		navBarClosed = true;
	}


  return (
	<div className="nav-bar">
		<button className="nav-bar-button" onClick={buttonHandler}><FaBars /></button>		
        <img className="nav-bar-logo" onClick={() => {window.scrollTo({top: 0, left: 0, behavior: 'smooth'})}} src={Logo} alt="Logo" />
		<div className='nav-bar-menu'>
			<div className="nav-bar-menu-leyend">
				<span>10% de descuento por pago en efectivo.</span>
			</div>
			<nav>
				<ul className='nav-bar-menu-list'>
					<li className='nav-bar-menu-button' onClick={linkHandler}><Link to="/tienda">Inicio</Link></li>
					<li className='nav-bar-menu-button' onClick={linkHandler}><NavLink to="/tienda/productos">Productos</NavLink></li>
					<li className='nav-bar-menu-button' onClick={linkHandler}><NavLink to="/tienda/combos">Combos</NavLink></li>
					<li className='nav-bar-menu-button' onClick={linkHandler}><a href="https://www.cotillonscraft.com.ar/nosotros">Nosotros</a></li>
				</ul>
			</nav>
		</div>
		<div className="nav-bar-commerce">
            <CartWidget />
        </div>
    </div>
  )
}

export default NavBar
